import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';
import { SpecificRequirementsSection } from 'src/app/shared/models/data/documentTemplate';
import { createDocumentEditor, DOCUMENT_TEMPLATE_TOOLBAR } from 'src/app/shared/ngx-editor/document-template-editor';

@Component({
  selector: 'app-customer-special-requirements-section',
  templateUrl: './customer-special-requirements-section.component.html',
  styleUrls: ['./customer-special-requirements-section.component.scss']
})
export class CustomerSpecialRequirementsSectionComponent implements OnDestroy {
  @Input() reset!: () => void;
  @Input() specificRequirements: SpecificRequirementsSection = {
    section: { value: '' }
  };
  @Output() specificRequirementsChange = new EventEmitter<SpecificRequirementsSection>();

  editor: Editor = createDocumentEditor();
  toolbar: Toolbar = DOCUMENT_TEMPLATE_TOOLBAR;

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  onEditorChange(newValue: string) {
    this.specificRequirements.section.value = newValue;
    this.specificRequirements.section.isModified = true;
    this.specificRequirementsChange.emit(this.specificRequirements);
  }
}
